import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { HelpCategoryDto, GET_HELP_CATEGORIES_QUERY_KEY } from './useHelpCategories';

export type CreateHelpCategoryInput = {
  nameEn: string;
  nameFr: string;
  descriptionEn?: string;
  descriptionFr?: string;
  slug: string;
  icon?: string;
  sortOrder?: number;
};

export const useCreateHelpCategory = (onSuccess: () => void) => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateHelpCategoryInput) =>
      client.fetchApi<HelpCategoryDto, CreateHelpCategoryInput>({ endpoint: 'help/admin/categories', method: 'POST', body: input }),
    onSuccess: () => {
      queryClient.invalidateQueries(GET_HELP_CATEGORIES_QUERY_KEY);
      onSuccess();
    },
  });
};
